<template>
  <IFrameContainer
    v-if="isFeatureEnabled !== null"
    :dashboard="GetDashboard"
    :project="isFeatureEnabled ? 'foodics' : 'skylineDynamics'"
    :merchant-uuid="merchantUuid"
  />
</template>

<script>
import IFrameContainer from '@/views/Admin/pages/Reports/components/IFrameContainer';
import { useFeatureFlags } from '@/hooks/useFeatureFlags';
import { Feature_Flags } from '@/enums/globals';
export default {
  name: 'ReportsLocations',
  components: {
    IFrameContainer,
  },
  data () {
    return {
      isFeatureEnabled: null,
    };
  },
  computed: {
    merchantUuid () {
      return this.$store.getters['page/getSoloLoyalty']?.attributes?.options?.[
        'merchant-uuid'
      ];
    },
    GetDashboard () {
      const isDunkin =
        this.$store.getters[
          'account/getConceptSettings'
        ]?.attributes?.label.includes('Dunkin\' ');
      if (isDunkin) {
        return this.isFeatureEnabled ? 106 : 32;
      } else {
        return this.isFeatureEnabled ? 103 : 21;
      }
    },
  },
  mounted () {
    const { isFeatureEnabled } = useFeatureFlags();
    this.isFeatureEnabled = isFeatureEnabled(
      Feature_Flags.METABASE_FOODICS_ALL_REPORTS,
    );
    // eslint-disable-next-line no-undef
    analytics.track('view_loyalty_report', {});
  },
};
</script>
